module.exports = __webpack_public_path__ + "images/website-7707b7db839c5e24e63d39b36d904244.svg";